import { render } from "./PropertySizeSvg.vue?vue&type=template&id=748aa9ea"
import script from "./PropertySizeSvg.vue?vue&type=script&lang=js"
export * from "./PropertySizeSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__